/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useMutation } from "@tanstack/react-query";
import { client } from "./api-client";

export const useGetReportsCITServices = () => {
  return useMutation({
    mutationFn: (data: any) =>
      client(`reports/cit/services`, {
        data,
      }),
  });
};

export const useGetReportsCashDeliveries = () => {
  return useMutation({
    mutationFn: (data: any) =>
      client(`reports/cit/cash/deliveries`, {
        data,
      }),
  });
};

export const useGetReportsCashCollection = () => {
  return useMutation({
    mutationFn: (data: any) =>
      client(`reports/cit/cash/collections`, {
        data,
      }),
  });
};

export const useGetVaultDailyReports = () => {
  return useMutation({
    mutationFn: (data: any) =>
      client(`reports/vault/daily/report`, {
        data,
      }),
  });
};

export const useGetAtmResidualsCashierReports = () => {
  return useMutation({
    mutationFn: (data: any) =>
      client(`reports/atm/residuals/cashier`, {
        data,
      }),
  });
};

export const useGetAtmCassettesFillingCashierReports = () => {
  return useMutation({
    mutationFn: (data: any) =>
      client(`reports/atm/cashier/cassettes/filling`, {
        data,
      }),
  });
};

export const useGetAtmDailyFieldReport = () => {
  return useMutation({
    mutationFn: (data: any) =>
      client(`reports/atm/daily/field/services`, {
        data,
      }),
  });
};

export const useGetAtmResidualsReport = () => {
  return useMutation({
    mutationFn: (data: any) =>
      client(`reports/atm/residuals/all`, {
        data,
      }),
  });
};

export const useGetAtmReplenishmentReport = () => {
  return useMutation({
    mutationFn: (data: any) =>
      client(`reports/atm/replenishments`, {
        data,
      }),
  });
};

export const useGetAtmDailyReconciliationsReport = () => {
  return useMutation({
    mutationFn: (data: any) =>
      client(`reports/atm/reconciliations`, {
        data,
      }),
  });
};

export const useGetAtmDiscrepanciesReport = () => {
  return useMutation({
    mutationFn: (data: any) =>
      client(`reports/atm/discrepancies`, {
        data,
      }),
  });
};

export const useGetAtmReportsHistory = () => {
  return useMutation({
    mutationFn: (data: any) =>
      client(`reports/atm/history`, {
        data,
      }),
  });
};

export const useGetCITFieldServicesReports = () => {
  return useMutation({
    mutationFn: (data: any) =>
      client(`reports/cit/daily/field/services`, {
        data,
      }),
  });
};

export const useGetCDMCollectionReport = () => {
  return useMutation({
    mutationFn: (data: any) =>
      client(`reports/cdms/collections`, {
        data,
      }),
  });
};

export const useGetCDMDiscrepanciesReport = () => {
  return useMutation({
    mutationFn: (data: any) =>
      client(`reports/cdms/discrepancies`, {
        data,
      }),
  });
};

export const useGetCDMHistoryReport = () => {
  return useMutation({
    mutationFn: (data: any) =>
      client(`reports/cdms/history`, {
        data,
      }),
  });
};

export const useGetCDMReconciliationsReport = () => {
  return useMutation({
    mutationFn: (data: any) =>
      client(`reports/cdms/reconciliations`, {
        data,
      }),
  });
};

export const useGetFieldTeamsRoasterReport = () => {
  return useMutation({
    mutationFn: (data: any) =>
      client(`reports/field/teams/roaster`, {
        data,
      }),
  });
};
